import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  constructor(private http: HttpClient) {}

  getTransactionsByEmail(email: string, page: number) {
    const url = `${environment.baseApiUrl}/transactions/${email}/${page}`;
    return url;
  }
}
